// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  guestId: __t.u64(),
  recipesCsv: __t.string(),
  appliancesCsv: __t.string(),
  cookSecondsCsv: __t.string(),
  pricesCsv: __t.string(),
  satisfactionsCsv: __t.string(),
};
